// TypeScript Type Definitions for Librario

export interface Config {
  authKey: string;
  groupByType: boolean;
  catalogs: CatalogConfig[];
  rpdbApiKey?: string;
  cacheValiditySeconds: number;
  addonName?: string;
  addonDescription?: string;
  enableMetadataFetching?: boolean;
  metadataProvider?: number; // 0=Cinemeta, 1=TMDB
  tmdbApiKey?: string;
}

export interface CatalogConfig {
  id: string;
  name: string;
  type: string; // Allow any string for custom type labels (e.g., "All", "Mixed", "Recently Watched")
  sortOrder: SortOrder;
  enabled: boolean;
  position: number;
  showRemovedItems?: boolean; // Show removed items in this catalog (default: false)
  isContinueWatching?: boolean; // Flag to identify Continue Watching catalog
}

export type SortOrder =
  | 'lastWatched'
  | 'recentlyAdded'
  | 'oldestAdded'      // NEW
  | 'name'
  | 'nameDesc'
  | 'watched'          // NEW
  | 'notWatched'       // NEW
  | 'timesWatched'
  | 'lastModified'
  | 'rating'           // DISABLED (kept for backward compat)
  | 'year'             // DISABLED (kept for backward compat)
  | 'yearAsc';         // DISABLED (kept for backward compat)

export interface PreviewItem {
  id: string;
  type: string;
  name: string;
  poster: string;
  year?: string;
}

export interface AuthStatus {
  authenticated: boolean;
  email?: string;
  error?: string;
}

export interface APIResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

export interface CacheTime {
  value: number;
  unit: 'seconds' | 'minutes' | 'hours';
}

// All sort options (for type safety)
export const ALL_SORT_OPTIONS: Record<SortOrder, string> = {
  lastWatched: 'Last Watched',
  recentlyAdded: 'Recently Added',
  oldestAdded: 'Oldest Added',
  name: 'Name',
  nameDesc: 'Name (Descending)',
  watched: 'Watched',
  notWatched: 'Not Watched',
  timesWatched: 'Times Watched',
  lastModified: 'Last Modified',
  rating: 'Rating',
  year: 'Year (Newest)',
  yearAsc: 'Year (Oldest)',
};

// TODO(GitLab #41): Re-enable rating/year sorts once metadata fetching is fixed
// Metadata-dependent sorts (rating, year) are disabled because they require
// fetching metadata for all items before sorting, which causes performance
// issues and incorrect ordering when metadata is missing.
export const ENABLED_SORT_OPTIONS: Record<string, string> = {
  lastWatched: 'Last Watched',
  recentlyAdded: 'Recently Added',
  oldestAdded: 'Oldest Added',
  name: 'Name',
  nameDesc: 'Name (Descending)',
  watched: 'Watched',
  notWatched: 'Not Watched',
  timesWatched: 'Times Watched',
  lastModified: 'Last Modified',
};

export const CONTENT_TYPES = ['movie', 'series', 'channel', 'tv'] as const;
export type ContentType = typeof CONTENT_TYPES[number];
